import { ProcessGameConfig, InitializeGame, CreateGameReducer } from 'boardgame.io/internal'

/** Returns Boardgame.io internals used only by client-side replay. */
export async function getBgioInternal() {
  return { ProcessGameConfig, InitializeGame, CreateGameReducer }
}
